import apiClient from '../lib/apiClient';

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      query.set(key, String(value));
    }
  });
  return query.toString() ? `?${query.toString()}` : '';
};

const logError = ({ status, response, url, error }) => {
  console.error('[pexelsService] Falha ao carregar mídia', {
    status,
    response,
    url,
    error: error?.message || null,
  });
};

const pexelsService = {
  async searchPhotos(params = {}) {
    const suffix = buildQuery(params);
    const url = `/pexels/search${suffix}`;

    try {
      const { response, data } = await apiClient.request(url, { auth: false, meta: true });

      if (!response?.ok || !data?.success) {
        logError({ status: response?.status, response: data, url });
        return {
          success: false,
          message: 'Não foi possível carregar imagens',
          items: [],
          page: 1,
          has_more: false,
        };
      }

      return {
        success: true,
        items: Array.isArray(data.items) ? data.items : [],
        page: Number(data.page || 1),
        has_more: Boolean(data.has_more),
      };
    } catch (error) {
      logError({ status: null, response: null, url, error });
      return {
        success: false,
        message: 'Não foi possível carregar imagens',
        items: [],
        page: 1,
        has_more: false,
      };
    }
  },

  async searchVideos(params = {}) {
    const suffix = buildQuery(params);
    const url = `/pexels/videos${suffix}`;

    try {
      const { response, data } = await apiClient.request(url, { auth: false, meta: true });

      if (!response?.ok || !data?.success) {
        logError({ status: response?.status, response: data, url });
        return {
          success: false,
          message: 'Não foi possível carregar vídeos',
          items: [],
          page: 1,
          has_more: false,
        };
      }

      return {
        success: true,
        items: Array.isArray(data.items) ? data.items : [],
        page: Number(data.page || 1),
        has_more: Boolean(data.has_more),
      };
    } catch (error) {
      logError({ status: null, response: null, url, error });
      return {
        success: false,
        message: 'Não foi possível carregar vídeos',
        items: [],
        page: 1,
        has_more: false,
      };
    }
  },
};

export default pexelsService;
